import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
  sm: Boolean,
  horizontal: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full bg-gray-1000 rounded-lg shadow-sm flex flex-col flex-wrap", {
      'p-3 2xl:p-6': !__props.sm,
      'p-2 2xl:p-4': __props.sm
    }])
  }, [
    (_ctx.$slots['title-horizontal'])
      ? (_openBlock(), _createElementBlock("h4", {
          key: 0,
          class: _normalizeClass(["text-2xs md:text-xs font-semibold uppercase tracking-wider text-gray-500 mt-auto", {
        'text-left': __props.horizontal,
        'text-center': !__props.horizontal
      }])
        }, [
          _renderSlot(_ctx.$slots, "title-horizontal")
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: _normalizeClass(["text-gray-200 text-xs xs:text-sm xl:text-xl", {
        'text-left': __props.horizontal,
        'text-center': !__props.horizontal,
        'mt-4': _ctx.$slots['title-horizontal']
      }])
    }, [
      _renderSlot(_ctx.$slots, "value")
    ], 2),
    _renderSlot(_ctx.$slots, "default"),
    (!_ctx.$slots['title-horizontal'])
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 1,
          class: ["text-2xs xs:text-xs text-center h-2 sm:h-3", {
        'mt-1 mb-2 xl:mb-3': !__props.sm,
        'mb-1 mt-px xl:mb-2': __props.sm,
        'text-left': __props.horizontal,
        'text-center': !__props.horizontal
      }]
        }, _ctx.$attrs), [
          _renderSlot(_ctx.$slots, "context")
        ], 16))
      : _createCommentVNode("", true),
    (_ctx.$slots['chart'])
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["-mt-2 xl:-mt-3", {
        'mb-6': !__props.sm,
        'mb-4': __props.sm
      }])
        }, [
          _renderSlot(_ctx.$slots, "chart")
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots['title'])
      ? (_openBlock(), _createElementBlock("h4", {
          key: 3,
          class: _normalizeClass(["text-2xs md:text-xs font-semibold uppercase tracking-wider text-gray-500 mt-auto", {
        'text-left': __props.horizontal,
        'text-center': !__props.horizontal
      }])
        }, [
          _renderSlot(_ctx.$slots, "title")
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})